import { LogLevel } from '@grafana/faro-web-sdk';
import { ApiBoardSettingsResponse } from '../../../api/core/models';
import { DEFAULT_BOARD_TIMELINE } from '../../../app.constants';
import { LoggingService } from '../../logging.service';
import { ClientBoardV2 } from '../model';

export function apiBoardSettingsToTimeline(
  loggingService: LoggingService,
  boardSettings?: ApiBoardSettingsResponse
): NonNullable<ClientBoardV2['boardSettings']['timeline']> {
  if (!boardSettings) {
    loggingService.logMessage('Board has no timeline, using default timeline', undefined, LogLevel.WARN);
    return DEFAULT_BOARD_TIMELINE;
  }
  return {
    boardStartYear: boardSettings.boardStartYear,
    boardEndYear: boardSettings.boardEndYear,
    scenarioStartYear: boardSettings.baselineYear,
    activityBasedInventoryStartYear: boardSettings.activityBasedInventoryStartYear || boardSettings.baselineYear,
    latestFinalisedInventoryYear: boardSettings.latestFinalisedInventoryYear || boardSettings.baselineYear,
  };
}
